import { LegalEntitySelector } from './LegalEntitySelector';

interface ConsigneeSelectorProps {
  value?: string;
  onChange?: (value: string) => void;
}

export const ConsigneeSelector = ({ value, onChange }: ConsigneeSelectorProps) => (
  <LegalEntitySelector
    value={value}
    onChange={onChange}
    placeholder='Select consignee'
    addNewLabel='Add New Consignee'
    modalTitle='Add New Consignee'
    addressType='DELIVERY'
  />
);
